import React from 'react';
import { Pressable } from 'react-native';

import { SvgIcon, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { useScaling } from '@/hooks';
import { guardianColors } from '@/theme/colors';

import { useStyles } from './styles';

const strings = STRINGS.onboarding.addPlayer;

/** "Delete player" action shown in edit mode only. Drops the queued player (the parent
 *  wires the actual removal + close through `onPress`). */
export function DeletePlayerButton({ onPress }: { onPress: () => void }) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Pressable onPress={onPress} hitSlop={8} style={styles.deleteButton} accessibilityRole="button">
      <SvgIcon name="IcXClose" size={scale(20)} color={guardianColors.Error} />
      <Text variant="Font Guardian App/Subtitle/Subtitle 14 Bold" style={styles.deleteLabel}>
        {strings.deletePlayer}
      </Text>
    </Pressable>
  );
}
